import { debugPrint } from "./utils/helpers"

export interface Product {
    id: number
    name: string
    // description: string
    price: number
}

export interface UserDataType {
    accounts: { [key: string]: AccountType }
    accountBeingDeleted?: string
    defaultAccount?: string
    hasLoaded: boolean,
    email?: string
    error?: string
    legalName?: string
    orders: { [key: string]: OrderType }
}

export type OrderStatus =
    | "new"                         // order created
    | "processing"                  // transfer initiated
    | "paid"                        // transfer settled & funds available
    | "cancelled"
    | "failed"
    | "refund-processing"
    | "refunded"
    | "refund-cancelled"
    | "refund-failed"

export interface OrderType {
    amount: number
    id: string
    plan: string
    status: OrderStatus
    timestamp: number
    transfers?: {
        [key: string]: TransferType
    }
}

type AccountStatus =
    | 'ITEM_LOGIN_REQUIRED'         // fixed with update
    | 'PENDING_DISCONNECT'          // fixed with update
    | 'USER_PERMISSION_REVOKED'     // show as locked -> remove
    | 'USER_ACCOUNT_REVOKED'        // show as locked -> remove
    | 'ERROR'                       // fixed with remove & add


export interface AccountType {
    accountId: string
    accessToken?: string
    bankName?: string
    itemId: string
    mask?: string
    statusCode?: AccountStatus
}


export interface ItemType {
    id: number
    plaid_item_id: string
    user_id: string
    plaid_access_token: string
    plaid_institution_id: string
    status: string
    created_at: string
    updated_at: string
}


/// Refers to https://plaid.com/docs/signal/#signal-data
interface RiskScore {
    score: number
    risk_tier?: number
}

export interface SignalScores {
    customer_initiated_return_risk?: RiskScore
    bank_initiated_return_risk?: RiskScore
}

export interface TransferType {
    id: string
    accountId: string
    amount: number
    createdAt: number          // UTC timestamp in milliseconds
    description: string
    orderId: string
    rationale?: string
    signalScores?: SignalScores
    status: string
    sweepStatus?: string
    updatedAt?: number          // UTC timestamp in milliseconds    
}

export function isTransferType(dict: any): dict is TransferType {
    const hasId = typeof dict.id === 'string'
    const hasAccountId = typeof dict.accountId === 'string'
    const hasAmount = typeof dict.amount === 'number'
    const hasCreatedAt = typeof dict.createdAt === 'number'
    const hasDescription = typeof dict.description === 'string'
    const hasOrderId = typeof dict.orderId === 'string'
    const hasStatus = typeof dict.status === 'string'
    const isValidTransfer = hasId && hasAccountId && hasAmount && hasCreatedAt && hasDescription && hasOrderId && hasStatus
    return isValidTransfer
}

export interface PaymentType {
    id: number
    user_id: number
    payments_total: number
    monthly_payment: number
    number_of_payments: number
    createdAt: string
    updatedAt: string
}

export interface PlaidTransferError {
    error_code: string
    error_message: string
    display_message: string
}